import { render } from "./LandingPageCard.vue?vue&type=template&id=1cc7f378&scoped=true"
import script from "./LandingPageCard.vue?vue&type=script&lang=js"
export * from "./LandingPageCard.vue?vue&type=script&lang=js"

import "./LandingPageCard.vue?vue&type=style&index=0&id=1cc7f378&scoped=true&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc7f378"]])

export default __exports__